import React, {useState} from "react";
import PropTypes from "prop-types";
import {Dialog, DialogTitle, DialogContent, Grid, Box, IconButton} from "@material-ui/core";
import {ArrowBackIos, ArrowForwardIos} from "@material-ui/icons";
import ItemView from "./ItemView";
// import AssetsLocationHistoryModal from "../../Assets/AssetsLocationHistoryModal";

const DetailsModal = ({
  visible,
  data,
  index,
  handleClose,
  handleNext,
  handlePrevious,
  sliderIndex,
  totalItems,
}) => {
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [detailsId, setDetailsId] = useState(null);

  const openHistory = (id) => {
    setDetailsId(id);
    setVisibleHistory(true);
  };

  const handleCloseHistory = () => {
    setVisibleHistory(false);
  };

  return (
    <Dialog open={visible} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" flexDirection="column">
            <span>{data.logistics_customer_main_asset_name}</span>
            <span style={{fontSize: 14, color: "grey", fontWeight: 500}}>SKU: {data.SKU}</span>
          </Box>
          <span style={{fontWeight: 500}}>
            {sliderIndex}/{totalItems}
          </span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" style={{minHeight: "250px"}}>
          <Grid item xs={1} container justify="center" alignItems="center">
            <IconButton onClick={handlePrevious}>
              <ArrowBackIos fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item xs={10}>
            <ItemView data={data} openHistory={openHistory} />
          </Grid>
          <Grid item xs={1} container justify="center" alignItems="center">
            <IconButton onClick={handleNext}>
              <ArrowForwardIos fontSize="large" />
            </IconButton>
          </Grid>
        </Grid>
        {/* <AssetsLocationHistoryModal
          visible={visibleHistory}
          id={detailsId}
          handleClose={handleCloseHistory}
        /> */}
      </DialogContent>
    </Dialog>
  );
};

DetailsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  index: PropTypes.number,
  handleClose: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
  sliderIndex: PropTypes.number,
  totalItems: PropTypes.number,
};

export default DetailsModal;
